import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FAQPageJsonLd } from 'next-seo';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';

import Collapse from 'components/Collapse/Collapse';
import sanitizer from 'utils/sanitizer';

import { StyledListItem } from './styles/List';

function SectionFAQ({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  const faqItems = formatMessage({ id: `cms.lifeInsurancePage.cardsArea[${index}].faqItems` });

  return (
    <>
      <Grid
        row
        id="faq"
        tag="section"
        spacingHorizontal={{
          xs: '4x',
          md: '8x',
          lg: '12x',
        }}
        spacingVertical={{
          xs: '16x',
          md: '20x',
          lg: '32x',
        }}
      >
        <Grid
          col={{ xs: 12, lg: 10 }}
          offset={{ lg: 1 }}
        >
          <Typography
            variant="title"
            color="black"
            colorVariant="default"
            gutterBottom={4}
            intlKey={`cms.lifeInsurancePage.cardsArea[${index}].title`}
          />
          <Box
            tag="ul"
          >
            {faqItems.map((question, questionIndex) => (
              <StyledListItem key={question.id}>
                <Collapse id={`account-faq-${question.id}`}>
                  <Collapse.Header>
                    <Typography
                      variant="subtitle"
                      marginBottom="2x"
                    >
                      {question.title}
                    </Typography>
                  </Collapse.Header>
                  <Collapse.Body>
                    {formatMessage({
                      id: `cms.lifeInsurancePage.cardsArea[${index}].faqItems[${questionIndex}].content`,
                    }, {
                      strong: props => (
                        <Typography
                          tag="strong"
                          variant="paragraph2"
                          {...props}
                        />
                      ),
                      p: props => <Typography variant="paragraph1" marginBottom={{ xs: '5x' }} {...props} />,
                      a: props => <Link {...props} />,
                    })}
                  </Collapse.Body>
                </Collapse>
              </StyledListItem>
            ))}
          </Box>
        </Grid>
        <Grid
          col={{ xs: 12, lg: 10 }}
          offset={{ lg: 1 }}
          spacingTop={{ xs: '8x', md: '16x', lg: '12x' }}
        >
          <Link
            href={formatMessage({ id: `cms.lifeInsurancePage.cardsArea[${index}].ctaLink` })}
            intlKey={`cms.lifeInsurancePage.cardsArea[${index}].ctaText`}
            variant="action"
          />
        </Grid>
      </Grid>
      <FAQPageJsonLd mainEntity={faqItems.map((_, questionIndex) => ({
        questionName: sanitizer.forJSON(formatMessage({ id: `cms.lifeInsurancePage.cardsArea[${index}].faqItems[${questionIndex}].title` })),
        acceptedAnswerText: sanitizer.forJSON(formatMessage({ id: `cms.lifeInsurancePage.cardsArea[${index}].faqItems[${questionIndex}].content` })),
      }))}
      />
    </>
  );
}

SectionFAQ.propTypes = {
  index: PropTypes.string.isRequired,
};

export default React.memo(SectionFAQ);
